import { useState, useEffect } from 'react';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const values = [
  { icon: 'ri-shield-check-line', title: 'Integrity', description: 'We operate with full transparency. Every license we facilitate is verified, every piece of advice is honest, and every client relationship is built on trust.' },
  { icon: 'ri-lightbulb-line', title: 'Expertise', description: 'Our team brings deep, hands-on experience across compliance, legal, tax, and corporate advisory so our clients always get informed, reliable guidance.' },
  { icon: 'ri-speed-line', title: 'Efficiency', description: 'We understand that time is money in regulated industries. We move fast, cut through complexity, and deliver results without unnecessary delays.' },
  { icon: 'ri-global-line', title: 'Global Reach', description: 'From Cyprus to Curaçao, Seychelles to Vanuatu. we operate across multiple jurisdictions and understand the nuances of each regulatory environment.' },
  { icon: 'ri-handshake-line', title: 'Client-First', description: 'Every decision we make is guided by what is best for our clients. We are not just service providers we are long-term partners in your business journey.' },
  { icon: 'ri-lock-line', title: 'Confidentiality', description: 'We handle all client information with the highest level of discretion. Your business details, transactions, and strategies remain strictly confidential.' },
];

export default function AboutValues() {
  const { ref: headRef, isVisible: headVisible } = useScrollAnimation();
  const { ref: gridRef, isVisible: gridVisible } = useScrollAnimation();
  const [visibleCards, setVisibleCards] = useState<boolean[]>(Array(values.length).fill(false));

  useEffect(() => {
    if (!gridVisible) return;
    values.forEach((_, i) => {
      setTimeout(() => {
        setVisibleCards((prev) => {
          const next = [...prev];
          next[i] = true;
          return next;
        });
      }, 100 * i);
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gridVisible]);

  return (
    <section className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
          ref={headRef as React.RefObject<HTMLDivElement>}
          className={`text-center mb-16 transition-all duration-700 ${headVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <span className="inline-block px-3 py-1 bg-amber-50 border border-amber-200 text-amber-600 text-sm font-semibold uppercase tracking-widest rounded mb-5">
            What We Stand For
          </span>
          <h2 className="text-4xl sm:text-5xl font-semibold text-slate-900 leading-tight">
            Our Core Values
          </h2>
        </div>

        <div
          ref={gridRef as React.RefObject<HTMLDivElement>}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
        >
          {values.map((v, i) => (
            <div
              key={i}
              className={`bg-slate-50 rounded-2xl p-8 border border-slate-100 hover:border-amber-200 hover:shadow-md transition-all group ${
                visibleCards[i] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
              style={{ transitionDuration: '600ms', transitionProperty: 'opacity, transform, box-shadow, border-color' }}
            >
              <div className="w-12 h-12 flex items-center justify-center bg-amber-500/10 rounded-xl mb-5 group-hover:bg-amber-500 transition-colors">
                <i className={`${v.icon} text-amber-500 text-xl group-hover:text-white transition-colors`}></i>
              </div>
              <h3 className="text-xl font-semibold text-slate-900 mb-3">{v.title}</h3>
              <p className="text-slate-600 leading-relaxed">{v.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
